function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, JSON) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-sh-summary-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($component.alert.anomaly) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Anomaly detection");;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Interesting segment");;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-sh-shared-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-formatted-message", {
            "attrs": {
              parts: JSON.stringify($component.message)
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;